<template>
  <div class="activity-page">
    <div class="banner-container">
      <!-- 1. 图片标签：确保加上 display: block 防止底部留白 -->
      <img
        src="https://filedlabeljs.ctaiot.com/dlabel_vue/dlabel_pc_web/img/active-page/double-twelve-pc.jpg"
        class="banner-img"
        alt="双12活动"
      />

      <!-- 2. 热区：全部改成 div -->
      <!-- 调试技巧：我暂时加上了背景色(红色)，方便你看位置，确认没问题后把 background 改回 transparent -->
      <div
        class="hotspot"
        style="top: 80.4%; left: 23%; width: 13%; height: 7.2%"
        @click="goDetail(384)"
      ></div>

      <div
        class="hotspot"
        style="top: 80.4%; left: 37%; width: 13%; height: 7.2%"
        @click="goDetail(389)"
      ></div>

      <div
        class="hotspot"
        style="top: 80.4%; left: 50.2%; width: 13%; height: 7.2%"
        @click="goDetail(390)"
      ></div>

      <div
        class="hotspot"
        style="top: 80.4%; right: 23%; width: 13%; height: 7.2%"
        @click="goDetail(794)"
      ></div>

      <div
        class="hotspot"
        style="top: 87.8%; left: 23%; width: 13%; height: 7.2%"
        @click="goDetail(449)"
      ></div>

      <div
        class="hotspot"
        style="top: 87.8%; left: 37%; width: 13%; height: 7.2%"
        @click="goDetail(138)"
      ></div>

      <div
        class="hotspot"
        style="top: 87.8%; left: 50.2%; width: 13%; height: 7.2%"
        @click="goDetail(741)"
      ></div>

      <div
        class="hotspot"
        style="top: 87.8%; right: 23%; width: 13%; height: 7.2%"
        @click="goDetail(509)"
      ></div>

      <!-- 底部按钮 -->
      <div
        class="hotspot"
        style="bottom: 0%; right: 0%; width: 100%; height: 4.6%"
        @click="goHome()"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityPage',
  methods: {
    goDetail(id) {
      // H5 项目使用 Vue Router 是对的
      this.$router.push({
        path: '/details',
        query: { id }
      });
    },
    goHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped>
.activity-page {
  width: 100%;
}

.banner-container {
  position: relative; // 核心：相对定位
  width: 100%;

  // 消除 img 标签在 div 中可能产生的底部 3px 间隙
  line-height: 0;

  .banner-img {
    width: 100%;
    height: auto; // 保持比例
    display: block; // 核心：块级元素
    border: none;
  }

  .hotspot {
    position: absolute; // 核心：绝对定位
    z-index: 10;
    cursor: pointer; // H5鼠标放上去变小手
  }
}
</style>
